import { render, staticRenderFns } from "./FilesViewFileDropEmptyContent.vue?vue&type=template&id=69bdbe8d&scoped=true"
import script from "./FilesViewFileDropEmptyContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesViewFileDropEmptyContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilesViewFileDropEmptyContent.vue?vue&type=style&index=0&id=69bdbe8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bdbe8d",
  null
  
)

export default component.exports